import Decimal from 'decimal.js';
import { OrderBookData } from '@/lib/types/order-book';

/** considering that passed book's intent is "yes" - transform it to "no" order book
 * return new order book
 */
export function invertOrderBook<T extends OrderBookData = OrderBookData>(book: T): T {
  return {
    ...book,
    asks: book.bids.map((bid) => {
      return {
        price: Decimal(1).minus(bid.price),
        size: Decimal(bid.size),
      };
    }),
    bids: book.asks.map((ask) => {
      return {
        price: Decimal(1).minus(ask.price),
        size: Decimal(ask.size),
      };
    }),
  };
}
